import {CPSConstants} from "commonUtils/enumerations";
import {clearAuthState} from "../redux/reducers/authSlice";
import {store} from "../redux/store";
import {logMessage} from "./loggerService";

export const ServiceAuthenticationException = (
  error?: any,
  data?: any,
  status?: number,
) => {
  try {
    logMessage("ERROR", error?.response?.data?.message, data?.pagename);
    if (error.response.data.messageCode === 22104) {
      window.location.href = CPSConstants.UNAUTH_QUERY_STRING;
    }
    if (error.response.data.messageCode === 12153) {
      window.location.href = CPSConstants.UNAUTH_QUERY_STRING_LOGOUT_SYSTEM;
    }
    if (error.response.data.messageCode === 251968) {
      window.location.href = CPSConstants.UNAUTH_QUERY_STRING_SESSION;
    } else {
      const unsubscribe = store.subscribe(() => {});

      store.dispatch(clearAuthState());
      unsubscribe();
    }
  } catch (error: any) {
    // TODO:Maria
    // Log the error data
    // We have to implement erroboundry over here
  }
};
export const HttpException = (error: any, data: any) => {
  try {
    logMessage("ERROR", error?.response?.data?.message, data?.pagename);
  } catch (error: any) {
    // TODO:Maria
    // Log the error data
    // We have to implement erroboundry over here
  }
};
